export enum Language {
	FR = "fr-FR",
	EN = "en-EN",
}